<template>
    <div class="extendable-card-list">
        <div class="extendable-card-list__card" v-for="(data) in cards" :key="'extendable-card-list-card-' + data.id">
            <button class="extendable-card-list__delete" :title="trans('buttons.remove')" @click.prevent="() => removeCard(data.id)">
                &times;
            </button>
            <sales-metrics-tile :tenants="tenants" :courses="courses" :id="data.id"></sales-metrics-tile>
        </div>

        <div class="extendable-card-list__empty" v-if="!cards.length">
            <alert type="info">
                {{ trans('vuetables.label.noResults') }}
            </alert>
        </div>

        <div class="extendable-card-list__add">
           <button type="button" @click="addCard" :title="trans('buttons.add')">
                <div class="icon-button icon-button--primary">
                    <div class="icon-button__icon">
                        <img src="/images/icons/create.svg" alt="">
                    </div>
                </div>
           </button>
        </div>
    </div>
</template>

<script>
import SalesMetricsTile from './SalesMetricsTile.vue';
export default {
    components: { SalesMetricsTile },
    props: [
        'tenants',
        'courses',
    ],
    data() {
        return {
            cards: [],
            max_id: 0,
        }
    },

    methods: {
        addCard() {
            this.max_id++;
            this.cards.push({'id': this.max_id});
        },
        removeCard(id) {
            var index = this.cards.findIndex(x => x.id === id);
            this.cards.splice(index, 1);
        },
    },

    mounted() {
    },
}
</script>
